import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { PatronProvider } from '../../providers/patron/patron';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { EventsProvider } from '../../providers/events/events';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

/**
 * Generated class for the CoPatronSignupInfoModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-patron-signup-info-modal',
  templateUrl: 'co-patron-signup-info-modal.html',
})
export class CoPatronSignupInfoModalPage {
  private patronInfo: any = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: ''};
  private agesList: any;
  private barcodeInput: string;
  private pinInput: string;
  private selectedAge: string;
  private guestList: Array<any> = [];
  private emailRegex: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private patronProvider : PatronProvider, public viewCtrl: ViewController, private events : Events, private timeout : TimeoutFunctionsProvider, private eventsProvider : EventsProvider, private toast : ToastAlertsProvider) {
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    if(this.navParams.data && this.navParams.data.hasOwnProperty('patron')){
      this.patronInfo = this.navParams.get('patron');
      if (this.patronInfo.barcode) this.barcodeInput = this.patronInfo.barcode;
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('ages')){
      this.agesList = this.navParams.get('ages');
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('email')){
      this.patronInfo = {};
      this.patronInfo['email'] = this.navParams.get('email');
    }
  }

  ionViewDidLoad(){
    if (this.patronInfo.ageGroup && this.agesList){
      this.selectedAge = this.agesList.find(a =>{return a.id == this.patronInfo.ageGroup}).id;
    }
  }

  findPatron(){
    this.patronProvider.getSummaryDetails(this.barcodeInput, this.pinInput).then(pat=>{
      this.patronInfo = pat;
    })
  }

  editAge(){
    this.patronInfo['ageGroup'] = this.selectedAge;
  }

  addGuest(){
    this.guestList.push({email: ''});
  }

  removeGuest(i){
    this.guestList.splice(i, 1);
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  validateEmail(){
    if (!this.patronInfo.email || this.patronInfo.email == ''){
      return true
    } else {
      return this.emailRegex.test(this.patronInfo.email);
    }
  }

  submitInfo(){
    if (this.selectedAge){
      if (this.validateEmail()){
        this.patronInfo['guestList'] = [];
        this.viewCtrl.dismiss({patron: this.patronInfo}).catch(err=>{});
      } else {
        this.toast.showAlert("","Please enter a valid email!","warning", 5000);
      }
    } else {
      this.toast.showAlert("","Please choose an age group!","warning", 5000);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-patron-signup-info-modal/co-patron-signup-info-modal.ts